var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('page-title',{attrs:{"icon":"fas fa-money-bill-alt"}},[_c('translate',[_vm._v("Transactions History")])],1),_vm._v(" "),_c('transactions-history')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }